import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';

import EventMap from '../screens/EventMap/EventMap';
import ExhibitorsMap from '../screens/EventMap/ExhibitorsMap';

export default props => (
    <Switch>
        <Route path={`${props.match.path}/exhibitors`} exact component={ExhibitorsMap} />
        <Route exact component={EventMap} />
        <Redirect to={`${props.match.path}`} />
    </Switch>
);
